export interface CheckboxTableItems {
  key: string;
  value: string;
}
